import React from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledButton = styled.button`
    padding: var(${GLOBAL_STYLE_CONFIG.variable('button', 'padding')}, ${({theme}) => theme.button.padding});

    border: 1px solid var(${GLOBAL_STYLE_CONFIG.variable('button', 'bg-color')}, ${({theme}) => theme.button.bgColor});
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('button', 'border-radius')}, ${({theme}) => theme.button.borderRadius});

    background-color: var(${GLOBAL_STYLE_CONFIG.variable('button', 'bg-color')}, ${({theme}) => theme.button.bgColor});

    color: var(${GLOBAL_STYLE_CONFIG.variable('button', 'text-color')}, ${({theme}) => theme.button.textColor});
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('button', 'font-size')}, ${({theme}) => theme.button.fontSize});
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('button', 'font-weight')}, ${({theme}) => theme.button.fontWeight});
    line-height: 120%;
    font-family: inherit;
    outline: none;

    box-shadow: 0 0 0 transparent;
    transition: all 0.250ms ease-in-out;

    max-width: 100%;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    &:hover {
        background-color: var(${GLOBAL_STYLE_CONFIG.variable('button', 'hover-bg-color')}, ${({theme}) => theme.button.hoverBgColor});
        border-color: var(${GLOBAL_STYLE_CONFIG.variable('button', 'hover-bg-color')}, ${({theme}) => theme.button.hoverBgColor});
    }

    &:active {
        background: var(${GLOBAL_STYLE_CONFIG.variable('button', 'active-bg-color')}, ${({theme}) => theme.button.activeBgColor});
        border-color:var(${GLOBAL_STYLE_CONFIG.variable('button', 'active-bg-color')}, ${({theme}) => theme.button.activeBgColor});
    }

    &:disabled {
        pointer-events: none;
        opacity: 0.5;
    }
`

interface IButtonProps extends React.HTMLProps<HTMLButtonElement> {
    children?: React.ReactNode;
}

const Button: React.FC<IButtonProps> = (props) => {
    const {
        children, type = "button", onClick = () => {
        }, disabled = false, className = ""
    } = props;
    return (
        <StyledButton type="button" onClick={onClick} disabled={disabled} className={className}>
            {props.children}
        </StyledButton>
    );
};

export default Button;